import { NextButton, SecondaryButton } from '@/components/buttons/Buttons';
import CardContainer from '@/components/cards/CardContainer';
import Container, { Column, Row } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { ListWithIcon } from '@/components/text/Lists';
import { TextHeadlineExtraExtraLarge, TextLabelLarge } from '@/components/text/Texts';
import { GET_STARTED } from '@/constants/button-labels';
import { DESCRIPTION, HEADER, KEY_BENEFITS } from '@/constants/travel-page';
import { MdCheck } from 'react-icons/md';
import { showTypedModal } from '@/common/common_utils';
import AddTravelProgramModal from '../views/AddTravelProgramModal';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/roles';

const TravelProgramHeader = () => {
	const isManager = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager]);

	return (
		<CardContainer>
			<Container className="p-[32px]">
				<Row gap="gap-[10px]">
					<Container className="py-[28px] w-[566px]">
						<Column>
							<TextHeadlineExtraExtraLarge
								text={HEADER}
								className="text-primary"
							/>
							<Spacing height="h-[20px]" />
							<TextLabelLarge text={DESCRIPTION} />
							<Spacing height="h-[24px]" />
							<ListWithIcon
								icon={
									<MdCheck
										size={24}
										className="text-info"
									/>
								}
								listItems={KEY_BENEFITS}
								gapBetweenIconAndText="gap-[10px]"
								gapBetweenListItems="gap-4"
							/>
						</Column>
						<Spacing height="h-[28px]" />
						<Row gap="gap-5">
							{isManager && (
								<NextButton
									id="travel-program-get-started"
									label={GET_STARTED}
									width="w-[169px]"
									withIcon
									onClick={async () => await showTypedModal(AddTravelProgramModal, {})}
								/>
							)}
							<SecondaryButton
								id="travel-program-view"
								label="View product demo"
								width="w-[228px]"
								onClick={() => { }}
							/>
						</Row>
					</Container>
					<Container className="flex self-end h-full w-[535px]">
						<img
							src="/images/travel.png"
							alt="travel image"
							height={404}
							width={535}
						/>
					</Container>
				</Row>
			</Container>
		</CardContainer>
	);
};

export default TravelProgramHeader;
